<template>
    <!-- The real PCMag asset; its red tile reads on the light band as-is. -->
    <img src="/img/brands/pc-mag.png" alt="PCMag" class="h-12 w-auto">
</template>
